module.exports = __webpack_public_path__ + "media/images/icons/Add-9abc211ce41391aa3124e4e866c990b2.svg";